export const REGEX_HELP_LINK = 'https://regex101.com/'

export const INTERCOM_ARTICLE_IDS = {
  // Datasources
  HOW_TO_CONNECT_A_DATASOURCE: 147846,
  GCP_DATASOURCE: 147848,
  ACCOUNT_RECONNECT_ERRORS_GUIDE: 529657,
  CRITEO_ACCOUNT_ACCESS_TROUBLESHOOTING: 671253,

  // Custom Groupings
  HOW_TO_CREATE_A_CUSTOM_GROUPING: 162536,

  // Attribution Models
  HOT_TO_SET_UP_AN_ATTRIBUTION_MODEL: 159703,
  ATTRIBUTION_MODELS_INTRODUCTION: 148181,
  TWO_WAYS_TO_MODEL_REVENUE: 419188,
  ATTRIBUTIONS_MODEL_CONFIDENCE_METRICS: 455145,
  ATTRIBUTION_CUSTOM_PRIORS: 159701,

  // Budget Optimiser
  BUDGET_OPTIMISER_INTRODUCTION: 148182,
  BUDGET_OPTIMISER_FACEBOOK_CONVERSION_ACTIONS: 221983,
  BUDGET_OPTIMISER_NOT_OPTIMISABLE: 696339,

  // Users & Workspace
  USER_ROLES_AND_PERMISSIONS: 147842,

  // Connectors
  CONNECTORS_INTRODUCTION: 148184,
  CONNECTORS_DEPRECATIONS: 373810,

  // Connectors > User Defined Report docs
  CONNECTORS_AMAZON_USER_DEFINED: 197374,
  CONNECTORS_BING_USER_DEFINED: 197402,
  CONNECTORS_CRITEO_USER_DEFINED: 197377,
  CONNECTORS_DV360_USER_DEFINED: 197380,
  CONNECTORS_FACEBOOK_USER_DEFINED: 197383,
  CONNECTORS_GOOGLE_ADS_USER_DEFINED: 197386,
  CONNECTORS_GOOGLE_ANALYTICS_4_USER_DEFINED: 197389,
  CONNECTORS_GOOGLE_SEARCH_CONSOLE_USER_DEFINED: 197393,
  CONNECTORS_GOOGLE_SHEETS_USER_DEFINED: 197396,
  CONNECTORS_LINKEDIN_USER_DEFINED: 197399,
  CONNECTORS_SNAPCHAT_USER_DEFINED: 197405,
  CONNECTORS_TIKTOK_USER_DEFINED: 197408,

  // Enhanced Signals
  ENHANCED_SIGNALS_INTRODUCTION: 148185,
  ENHANCED_SIGNALS_TARGET_SELECTION: 222645,
  ENHANCED_SIGNALS_TRANSFORMATION_SELECTION: 222644,
  ENHANCED_SIGNALS_EVENT_LOOKUP_VALUE_TRANSFORMATION: 222642,
  ENHANCED_SIGNALS_ITEM_LOOKUP_VALUE_TRANSFORMATION: 222643,
  ENHANCED_SIGNALS_GA4_GTAG: 222646,
  ENHANCED_SIGNALS_GA4_FIREBASE: 222647,
  ENHANCED_SIGNALS_GOOGLE_TAG_MANAGER: 222648,
  ENHANCED_SIGNALS_GOOGLE_ADS_CLICK_CONVERSIONS: 222649,
  ENHANCED_SIGNALS_META_CONVERSION_API: 222650,

  // Reporting Solutions
  REPORTING_SOLUTIONS_INTRODUCTION: 148183,
  REPORTING_SOLUTIONS_DEPRECATIONS: 183211,
  REPORTING_SOLUTIONS_PRECIS_STARTER_REPORT: 175810,
  REPORTING_SOLUTIONS_LOOKER_STUDIO_HELP: 174851,
  REPORTING_SOLUTIONS_LOOKER_STUDIO_SOMETHING_WENT_WRONG_WHEN_BUILDING_YOUR_REPORT: 183201,
  REPORTING_SOLUTIONS_LOOKER_STUDIO_NO_DATA_SET_ACCESS_INSUFFICIENT_PERMISSIONS_TO_THE_UNDERLYING_DATA_SET: 183197,
  REPORTING_SOLUTIONS_STARTER_REPORT_ADD_ATTRIBUTION_MODELS: 449713,

  // Recommendations
  RECOMMENDATIONS_INTRODUCTION: 1,

  // Datasources
  GOOGLE_ANALYTICS_UA: 147852,
  GOOGLE_ANALYTICS_4: 147851,
  GOOGLE_ADS: 147850,
  AMAZON_ADS: 147856,
  DV360: 147849,
  GOOGLE_SEARCH_CONSOLE: 147854,
  GOOGLE_MERCHANT_CENTER: 147853,
  GOOGLE_CLOUD_PLATFORM: 147848,
  MICROSOFT_ADS: 147859,
  LINKEDIN: 147858,
  FACEBOOK_ADS: 147857,
  SNAPCHAT: 147860,
  TIKTOK: 147861,
  GOOGLE_SHEETS: 147855,
  PINTEREST: 570097,

  // Creative Reporting
  CREATIVE_REPORTING_INTRODUCTION: 455010,
  CREATIVE_REPORTING_REPORT_SETUP_GUIDE: 468266,
  CREATIVE_REPORTING_CANT_SEE_ADS: 457405
} as const

export type IntercomArticleId = (typeof INTERCOM_ARTICLE_IDS)[keyof typeof INTERCOM_ARTICLE_IDS]

export const INTERCOM_SPACE_IDS = {
  HOME: 'home',
  HELP: 'help',
  MESSAGES: 'messages'
} as const

export type IntercomSpaceId = (typeof INTERCOM_SPACE_IDS)[keyof typeof INTERCOM_SPACE_IDS]
